import $ from "jquery";
import { addUrlParam } from "../utils/addUrlParam.js";
import { urlParam } from "../utils/urlParam.js";
const WP_TABLE_LIST_SELECTOR = ".wp-list-table.media tbody, .wp-list-table.attachments tbody";
function resolveAttachmentsSortableView(attachmentsBrowser) {
    if (!attachmentsBrowser) {
        return undefined;
    }
    return attachmentsBrowser.attachments;
}
function isAttachmentsSortableWidgetInitialized($el) {
    return $el.hasClass("ui-sortable") || !!$.data($el[0], "ui-sortable");
}
function ensureAttachmentsSortableInitialized(attachments) {
    if (!attachments?.$el?.length || !attachments.initSortable) {
        return;
    }
    if (isAttachmentsSortableWidgetInitialized(attachments.$el)) {
        return;
    }
    if (!attachments.options.sortable) {
        attachments.options.sortable = {};
    }
    attachments.initSortable();
}
function isOrderByReadyForSortable(attachmentsBrowser) {
    return isOrderByActive(attachmentsBrowser) || isOrderByActive(attachmentsBrowser, "date", "DESC");
}
const ATTACHMENT_FILTER_PROP_EVENTS = [
    "change:monthnum",
    "change:year",
    "change:uploadedTo",
    "change:type",
    "change:author",
    "change:search"
];
function bindAttachmentFilterListener(attachmentsBrowser, onChange) {
    const collection = attachmentsBrowser?.collection;
    if (!collection?.props) {
        onChange(false);
        return undefined;
    }
    const notify = ()=>onChange(isFilterActive(attachmentsBrowser));
    const $attachmentFilter = findAttachmentFiltersSelect(attachmentsBrowser);
    ATTACHMENT_FILTER_PROP_EVENTS.forEach((event)=>collection.props.on(event, notify));
    collection.on("reset", notify);
    $attachmentFilter.on("change", notify);
    notify();
    return ()=>{
        ATTACHMENT_FILTER_PROP_EVENTS.forEach((event)=>collection.props.off(event, notify));
        collection.off("reset", notify);
        $attachmentFilter.off("change", notify);
    };
}
function applyToAttachmentsBrowser(attachmentsBrowser, selected, orderby = "rml", order = "ASC") {
    let filter;
    if (attachmentsBrowser && (filter = attachmentsBrowser.toolbar.get("rml_folder").filters[selected.id])) {
        const { props } = attachmentsBrowser.collection;
        const o = {
            silent: true
        };
        if (selected.contentCustomOrder === 1 || selected.forceCustomOrder) {
            filter.props.orderby = "rml";
            filter.props.order = "ASC";
            props.set({
                orderby,
                order
            }, o);
        } else {
            delete filter.props.orderby;
            delete filter.props.order;
            props.set({
                orderby: "date",
                order: "DESC"
            }, o);
        }
    }
}
async function relocateAttachment(message, node, attachmentId, nextId, lastIdInView, ui) {
    if (process.env.PLUGIN_CTX !== "pro") {
        return;
    }
/* Silence is golden... Until you have PRO Version! */ }
function resolveAttachmentsBrowser(attachmentsBrowser) {
    const attachments = resolveAttachmentsSortableView(attachmentsBrowser);
    if (attachments?.$el?.length) {
        return attachmentsBrowser;
    }
    const domBrowser = $(".media-modal .attachments-browser, .attachments-browser").first().data("backboneView");
    return domBrowser ?? attachmentsBrowser;
}
function findAttachmentFiltersSelect(attachmentsBrowser) {
    const browser = attachmentsBrowser;
    const inBrowser = browser.$el?.find("#media-attachment-filters");
    if (inBrowser?.length) {
        return inBrowser;
    }
    return $(".media-modal:visible #media-attachment-filters").first();
}
function isSingleImageMimeTypeFrame(browser) {
    const mimeType = browser.controller?.options?.mimeType;
    if (!mimeType) {
        return false;
    }
    const allowed = Array.isArray(mimeType) ? mimeType : [
        mimeType
    ];
    return allowed.length === 1 && allowed[0] === "image";
}
function hasActiveFilterPropValue(filterKey, value) {
    if (value === undefined || value === null || value === "") {
        return false;
    }
    // `uploadedTo: 0` is WordPress' "Unattached" filter.
    if (filterKey === "uploadedTo") {
        return true;
    }
    return !!value;
}
function isWpAttachmentToolbarFilterActive(attachmentsBrowser) {
    const browser = attachmentsBrowser;
    const value = findAttachmentFiltersSelect(browser).val();
    if (value === undefined || value === null || value === "") {
        return false;
    }
    if (value !== "all") {
        return true;
    }
    // Featured-image modal labels the default option "Images" but keeps value "all".
    return isSingleImageMimeTypeFrame(browser);
}
function isFilterActive(attachmentsBrowser) {
    if (attachmentsBrowser) {
        const browser = attachmentsBrowser;
        if (isWpAttachmentToolbarFilterActive(browser)) {
            return true;
        }
        const filters = [
            "monthnum",
            "year",
            "uploadedTo",
            "type",
            "author",
            "search"
        ];
        const { props } = browser.collection;
        for(let i = 0; i < filters.length; i++){
            const filterKey = filters[i];
            const value = props.get(filterKey);
            if (!hasActiveFilterPropValue(filterKey, value)) {
                continue;
            }
            return true;
        }
        return false;
    }
    return !!urlParam("attachment-filter");
}
function isOrderByActive(attachmentsBrowser, orderby = "rml", order = "ASC") {
    if (attachmentsBrowser) {
        const { props } = attachmentsBrowser.collection;
        const propOrder = props.get("order") || "DESC";
        return props.get("orderby") === orderby && propOrder.toUpperCase() === order.toUpperCase();
    }
    const propOrder = urlParam("order") || "DESC";
    return urlParam("orderby") === orderby && propOrder.toUpperCase() === order.toUpperCase();
}
function orderUrl(href = window.location.href) {
    return addUrlParam(addUrlParam(href, "orderby", "rml"), "order", "asc");
}
function toggleSortable(selected, mode, attachmentsBrowser, message) {
    if (process.env.PLUGIN_CTX === "lite") {
        return false;
    }
/* Silence is golden... Until you have PRO Version! */ }
export { bindAttachmentFilterListener, isFilterActive, WP_TABLE_LIST_SELECTOR, applyToAttachmentsBrowser, orderUrl, relocateAttachment, toggleSortable };
